import React from 'react';
import { Link, LinkProps } from 'react-router-dom';

// prevents passing all props to <a> when used with styled-components
const StylableRouterLink = ({
  component,
  to,
  replace,
  innerRef,
  children,
  onClick,
  className,
  tabIndex,
}: Pick<
  LinkProps,
  | 'component'
  | 'to'
  | 'replace'
  | 'innerRef'
  | 'children'
  | 'onClick'
  | 'className'
  | 'tabIndex'
>) => (
  <Link
    tabIndex={tabIndex}
    className={className}
    component={component}
    replace={replace}
    innerRef={innerRef}
    to={to}
    onClick={onClick}
  >
    {children}
  </Link>
);

export default StylableRouterLink;
